import LeftMenuItem from "./LeftMenuItem"
import { useCan } from "../../hooks/useCan"

const LeftMenuBlock = ({ name, itemArray, isCollapsed }) => {
  const visibleItems = itemArray.filter((item) => {
    // Either no permission required or user has the permission
    return !item.permission || useCan(item.permission)
  })

  if (visibleItems.length === 0) return null


  return (
    <div className="sidebar-menus">
      <h6
        style={{
          padding: isCollapsed ? 0 : "0 0 0 17px",
          textAlign: isCollapsed ? "center" : "left"
        }}>
        {name}
      </h6>

      <ul>
        {itemArray.map((item) => (
          <LeftMenuItem key={item.name} menuItem={item} isCollapsed={isCollapsed} />
        ))}
      </ul>
    </div>
  )
}

export default LeftMenuBlock
